<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期：">
            <el-date-picker size="medium" v-model="searchForm.PICK_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <tooltip-button button-text="打印拣货单" @click="selectWarehouseArea" :disabled="Boolean(searchForm.PICK_DAY)" tip-content="请选择日期">
            </tooltip-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <h2>历史拣货单</h2>
    </el-row>
    <el-row>
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期：">
            <el-date-picker v-model="searchForm.PICK_DAY_HISTORY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" @click="queryHistoryPick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="拣货单号" prop="PICK_CODE" min-width="100px"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openDetail(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--       -----------------------选择分区模态框-->
    <el-dialog :visible.sync="selectWarehouseAreaDialogVisible" title="打印拣货单" width="400px" center>
      <el-form :model="selectWarehouseAreaForm" ref="addForm" size="small" label-width="90px">
        <el-form-item label="仓库区域:">
          <el-select filterable v-model="selectWarehouseAreaForm.WarehouseArea" clearable>
            <el-option v-for="item in WarehouseAreaList" :key="item.ID" :label="item.TYPE_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="selectWarehouseAreaDialogVisible= false">取消</el-button>
        <el-button class="operate-btn" @click="getPrintAllPick()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  WMSpickListAll, print, WMShistoryPickList, queryWarehouseType,
} from '@/assets/api/warehouseManager';
import { frontEndFun } from '@/assets/api/frontFun';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      PAGE_ID: '11207', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1120701: 0 }, // 功能ID 一旦规定不要轻易改动
      tableData: [],
      dialogVisible: false,
      inwareDate: [],
      WarehouseAreaList: [],
      name: '',
      pro_type: '',
      total_count: 0,
      currentPage: 1,
      totalCount: 0,
      form: {},
      pName: '',
      returnDialogVisible: false,
      selectWarehouseAreaDialogVisible: false,
      region: '',
      deliverId: '',
      arr: [],
      searchForm: {
        PICK_DAY: '',
      },
      selectWarehouseAreaForm: {
        WarehouseArea: '',
      },
      pickListAll: [],
      pickListSeparate: [],
      pick_id: '',
      lackList: [],
      unpackList: [],
    };
  },
  created() {
    this.queryWarehouseArea();
    this.queryBeforeFun();
    if (this.PICKINGLIST_CONDITION.CONDITION) {
      this.searchForm = this.PICKINGLIST_CONDITION.CONDITION;
    }
    if (this.PICKINGLIST_CONDITION.HISTORY) {
      this.tableData = this.PICKINGLIST_CONDITION.HISTORY;
    }
  },
  computed: {
    // 上一次的搜索结果和条件
    PICKINGLIST_CONDITION() {
      return this.$store.state.PICKINGLIST_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    posionFun() {
      this.pName = this.form.region;
    },
    handleCurrentChange(e) {
      this.currentPage = e;
    },
    openDetail(row) {
      this.$router.push({ name: 'pickingListDetail', params: { PICK_CODE: row.PICK_CODE } });
    },
    selectWarehouseArea() {
      this.selectWarehouseAreaDialogVisible = true;
    },
    getPrintAllPick() {
      const params = {
        DELIVER_DAY: this.searchForm.PICK_DAY,
      };
      if (this.selectWarehouseAreaForm.WarehouseArea) {
        params.WS_TYPE_ID = this.selectWarehouseAreaForm.WarehouseArea;
      }
      WMSpickListAll(params).then((result) => {
        this.pickListAll = result[0].TOTAL_PICK_LIST.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        this.pickListSeparate = result[0].SEPARATE_PICK_LIST.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        this.lackList = result[0].LACK_LIST;
        this.pick_id = result[0].PICK_CODE;
        this.unpackList = result[0].UNPACK_LIST;
        this.printPick();
        this.$store.dispatch('SET_PICKINGLIST_CONDITION', {
          CONDITION: this.searchForm,
        });
        window.location.href = util.getURLLocalHost(result[0].URL);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取温区
    queryWarehouseArea() {
      queryWarehouseType().then((result) => {
        if (result.length) {
          this.WarehouseAreaList = result;
        } else {
          this.WarehouseAreaList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    printPick() {
      this.mergePostion();
      let html = '<div>';
      html += '<div class="main">';
      html += '<div class="title">总拣单</div>';
      html += `<div class="head"><div class="code">单号：${this.pick_id}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th style="width: 140px">库位</th><th>产品</th><th style="width: 120px">编码</th> <th  style="width: 40px">单位</th><th style="width: 70px">总数</th><th  style="width: 100px">生产日期</th></tr>';
      html += '</div><div class="el-table__body">';
      this.pickListAll.forEach((item, index) => {
        if (item.count) {
          html += '<tr style="text-align: center">';
          html += `<td> ${index + 1} </td><td rowspan="${item.count}">${item.LOCATION_CODE}</td> <td>${item.NAME}</td> <td>${item.PRODUCT_CODE}</td> <td>${item.UNIT}</td>
                            <td>${item.PRODUCT_COUNT}</td> <td>${item.PRODUCTION_DATE}</td>`;
          html += '</tr>';
        } else {
          html += '<tr style="text-align: center">';
          html += `<td> ${index + 1} </td> <td>${item.NAME}</td> <td>${item.PRODUCT_CODE}</td> <td>${item.UNIT}</td>
                            <td>${item.PRODUCT_COUNT}</td> <td>${item.PRODUCTION_DATE}</td>`;
          html += '</tr>';
        }
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += '</div>';
      // 分拣单
      html += '<div style="page-break-after: always;"></div>';
      html += '<div>';
      html += '<div class="main">';
      html += '<div class="title">分拣单</div>';
      html += `<div class="head"><div class="code">单号：${this.pick_id}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>产品</th> <th style="width: 120px">编码</th> <th  style="width: 40px">单位</th><th style="width: 70px">数量</th><th>项目点</th><th  style="width: 100px">生产日期</th></tr>';
      html += '</div><div class="el-table__body">';
      this.pickListSeparate.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.NAME}</td> <td>${item.PRODUCT_CODE}</td> <td>${item.UNIT}</td>
                        <td>${item.PRODUCT_COUNT}</td><td>${item.PROJECT_NAME}</td><td>${item.PRODUCTION_DATE}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += '</div>';
      // eslint-disable-next-line no-unused-vars
      const windows = print(html);
    },
    queryHistoryPick() {
      if (!this.searchForm.PICK_DAY_HISTORY) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      const params = {
        DELIVER_DAY: this.searchForm.PICK_DAY_HISTORY,
      };
      WMShistoryPickList(params).then((result) => {
        this.tableData = result;
        this.$store.dispatch('SET_PICKINGLIST_CONDITION', {
          CONDITION: this.searchForm,
          HISTORY: this.tableData,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 按库位合并单元格
    mergePostion() {
      let now_postion = '    ';
      let start_index = 0;
      let count = 1;
      for (let i = 0; i < this.pickListAll.length; i++) {
        if (this.pickListAll[i].LOCATION_CODE !== now_postion) {
          this.pickListAll[start_index].count = count;
          count = 1;
          this.pickListAll[i].count = count;
          start_index = i;
          now_postion = this.pickListAll[i].LOCATION_CODE;
        } else {
          count += 1;
          this.pickListAll[start_index].count = count;
        }
      }
    },
  },

};
</script>
<style  scoped>
.el-select {
  margin-right: 15px;
}

.el-input {
  margin-right: 15px;
  width: 200px;
}

.tableArea {
  margin-top: 20px;
}

i[class^="el-icon"] {
  margin-right: 5px;
  font-size: 16px;
  cursor: pointer;
}

.modify_table td {
  padding: 10px;
}

.item_title {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingList.vue